import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from './Logo';

export const GlobalLoader = () => {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } }}
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-brand-deep overflow-hidden"
    >
      {/* Subtle Background Particles */}
      <svg className="absolute inset-0 w-full h-full opacity-20" aria-hidden="true">
        {[...Array(12)].map((_, i) => (
          <motion.circle
            key={i}
            initial={{ opacity: 0, y: "110%" }}
            animate={{
              opacity: [0, 0.4, 0],
              y: ["110%", "-10%"],
              x: [`${Math.random() * 100}%`, `${Math.random() * 100}%`]
            }}
            transition={{
              duration: 3 + Math.random() * 2,
              repeat: Infinity,
              ease: "linear",
              delay: Math.random() * 1
            }}
            r={1 + Math.random() * 2}
            fill="#F6DCE8"
          />
        ))}
      </svg>

      {/* Central Soft Pulse Glow */}
      <motion.div
        animate={{ scale: [0.8, 1.1, 0.8], opacity: [0.15, 0.3, 0.15] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] bg-brand-pink/30 blur-[100px] rounded-full"
      />

      <div className="relative z-10 flex flex-col items-center">
        {/* Logo container with fade and subtle scale */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="relative flex justify-center items-center mb-8"
        >
          <Logo isDark={true} className="relative z-10 h-[40px] md:h-[56px]" />
        </motion.div>

        {/* Text Animation */}
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
          className="text-center flex flex-col items-center"
        >
          <p className="text-brand-pink/70 text-[10px] md:text-xs font-bold uppercase tracking-[0.2em] mt-4">
            Building The Systems That Power Tomorrow.
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};